import toast from 'react-hot-toast';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import config from '../../../config';
import getBrowserInfo from '../../utils/getBrowserInfo';
import getDeviceType from '../../utils/getDeviceType';
// import getRandomString from "../../utils/getRandomString";
import getOrCreateDeviceIdentity from '../../utils/getOrCreateDeviceKey';
import { editUser, editPublisher } from '../../actions';
import {
  setAuthToken,
  setRefreshToken,
  setDeviceIdentity,
  removeAuthToken,
  removeRefreshToken,
  removeDeviceIdentity
} from '../../utils/auth';
import { setItem, getItem } from '../../utils/localStorageFn';

// send Post data to fewcents db
async function createArticles(history) {
  const userData = JSON.parse(getItem('userdata'));
  const { accessToken } = userData;
  const userId = userData.user.id;
  const publisherData = JSON.parse(getItem('publisherdata'));
  const publisherId = publisherData.id;
  const postsData = JSON.parse(getItem('postsdata'));

  const body = JSON.stringify({
    articleList: postsData,
    publisherId,
    userId
  });

  const requestOptions = {
    method: 'POST',
    headers: {
      'content-type': 'application/json',
      Authorization: `Bearer ${accessToken}`
    },
    body
  };

  try {
    // eslint-disable-next-line no-unused-vars
    const response = await fetch(`${config.ApiBaseUrl}/wordpress/createArticles`, requestOptions);

    // const response_parsed = await response.json();
    // console.log(response_parsed);
    console.log('test:', history);
    history.push('/content');
  } catch (e) {
    console.log(e);
  }
}

async function retrievePosts(history) {
  const userData = JSON.parse(getItem('userdata'));
  const authorName = userData.user.name;
  return new Promise((resolve, reject) => {
    // eslint-disable-next-line no-undef
    jQuery(document).ready(async ($) => {
      // console.log(ajaxurl);
      // This does the ajax request (The Call).
      await $.ajax({
        // eslint-disable-next-line no-undef
        url: ajaxurl,
        data: {
          post_type: 'POST',
          requestFor: 'retrieve_posts',
          action: 'process_post_request', // This is our PHP function below
          author_name: authorName
        },
        async success(data) {
          // console.log(JSON.parse(data));
          setItem('postsdata', data);
          await createArticles(history);
          resolve(JSON.parse(data));
        },
        error(errorThrown) {
          console.log(errorThrown);
          reject(errorThrown);
        }
      });
      // createArticles();
    });
  });
}

async function injectScript(history) {
  const publisherData = JSON.parse(getItem('publisherdata'));
  const { accessKey } = publisherData;
  let { logoURL } = publisherData;
  logoURL = logoURL === undefined || logoURL === null || logoURL === '' ? `${config.defaultLogoUrl}` : logoURL;
  const headerUrl = `${config.headerUrl}`;
  return new Promise((resolve, reject) => {
    // eslint-disable-next-line no-undef
    jQuery(document).ready(async ($) => {
      // This does the ajax request (The Call).
      await $.ajax({
        // eslint-disable-next-line no-undef
        url: ajaxurl,
        data: {
          post_type: 'POST',
          requestFor: 'inject_script',
          action: 'process_post_request', // This is our PHP function below
          access_key: accessKey,
          logo_url: logoURL,
          header_url: headerUrl
        },
        // eslint-disable-next-line no-unused-vars
        async success(data) {
          // console.log(data);
          await retrievePosts(history);
          resolve(data);
        },
        error(errorThrown) {
          console.log(errorThrown);
          reject(errorThrown);
        }
      });
    });
  });
}

const signUpFlow = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const createPublisher = (
    bankAccountNumber,
    bankName,
    companyCurrency,
    companyName,
    companyTaxId,
    domain,
    phoneNumber,
    logoUrl,
    brandName,
    registeredAddress,
    registeredCountry,
    registrationNumber,
    signatoryDesignation,
    signatoryName,
    changeModalText,
    setShowModal
    // setShowVerifyAccessToken
  ) => {
    console.log('creating publisher');
    changeModalText('creating publisher');

    /* Remove after cleaning up  */
    setItem('domain', domain);

    const userData = JSON.parse(getItem('userdata'));
    const payload = {
      bankAccountNumber,
      bankName,
      bookCurrencyCode: 'INR',
      companyCurrency,
      companyName,
      companyTaxId,
      // eslint-disable-next-line no-undef
      // eslint-disable-next-line radix
      createdByUserId: parseInt(userData.user.id),
      // TODO: needs to be replaced with user browser domain!
      domain, // timesofindia.com
      financeEmail: userData.user.email, /// /=> should be just a valid email
      // TODO: needs get phone number from user!
      financePhone: `+91${phoneNumber}`, //= > should be + and numbers
      isGeoFencingEnabled: true,
      logoURL: logoUrl, //= > static url path to their logo image
      name: brandName, //= > their brand name ex Times of India
      pointOfContactEmail: userData.user.email,
      registeredAddress,
      registeredCountry,
      registrationNumber,
      signatoryDesignation,
      signatoryName,
      unlockDiv: '' //= > ignore
    };

    (async () => {
      try {
        const { accessToken } = userData;
        const response = await fetch(`${config.ApiBaseUrl}/wordpress/createPublisher`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${accessToken}`
          },
          body: JSON.stringify(payload)
        });
        const json = await response.json();
        const { data, message, success } = json;
        if (!success) throw new Error(message ?? 'Something went wrong. failed to process request');

        dispatch(editPublisher(data.publisher));
        setItem('publisherdata', JSON.stringify(data.publisher));

        if (!data.publisher.isKycComplete) {
          removeAuthToken();
          removeRefreshToken();
          removeDeviceIdentity();

          setShowModal(false);
          setItem('isloginflow', false);
          history.push('/accesskey');
        } else {
          await injectScript(history);
        }
      } catch (e) {
        removeAuthToken();
        removeRefreshToken();
        removeDeviceIdentity();

        setShowModal(false);
        toast.error(e.message);
        console.log(e);
      }
    })();
  };

  const createAdmin = ({
    name,
    email,
    password,
    domain,
    phoneNumber,
    brandName,
    logoUrl,
    role,
    companyName,
    registrationNumber,
    registeredCountry,
    registeredAddress,
    signatoryName,
    signatoryDesignation,
    bankName,
    bankAccountNumber,
    companyCurrency,
    companyTaxId,
    changeModalText,
    setShowModal
    // setShowVerifyAccessToken,
  }) => {
    let browserInfo = {};

    if (window.navigator) {
      const { userAgent, platform } = window.navigator;
      browserInfo = {
        browser: getBrowserInfo(userAgent),
        deviceKey: getOrCreateDeviceIdentity(),
        os: platform || 'unknown',
        type: getDeviceType(userAgent),
        userAgent
      };
    }

    const payload = {
      ...browserInfo,
      accessToken: '',
      email,
      idToken: '',
      name,
      password,
      refreshToken: '',
      role
    };

    changeModalText('creating user...');

    (async () => {
      try {
        const response = await fetch(`${config.ApiBaseUrl}/wordpress/createAdmin`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        });
        const json = await response.json();

        const { data, message, success } = json;

        if (!success) throw new Error(message ?? 'Something went wrong. failed to process request');

        /**
         * Storing inside the redux global state
         */
        dispatch(editUser(data.user));
        setItem('userdata', JSON.stringify(data));

        setAuthToken(data.accessToken);
        setRefreshToken(data.refreshToken);
        setDeviceIdentity(data.deviceKey);

        createPublisher(
          bankAccountNumber,
          bankName,
          companyCurrency,
          companyName,
          companyTaxId,
          domain,
          phoneNumber,
          logoUrl,
          brandName,
          registeredAddress,
          registeredCountry,
          registrationNumber,
          signatoryDesignation,
          signatoryName,
          changeModalText,
          setShowModal
          // setShowVerifyAccessToken
        );
      } catch (e) {
        setShowModal(false);
        toast.error(e.message);
        console.log(e);
      }
    })();
  };

  return createAdmin;
};

export { signUpFlow, injectScript };
